<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">Geronimo’s Story of His Life</h1>
<h2 class="center" style="margin-top:20px;"></h2>
<h3 class="center" style="margin-top:60px;">As told to S. M. Barrett</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled1.vue?2715eac4